export enum PagesRoute {
  PCP = '/[locale]/products/[category]',
}
